import React, { useEffect, useState, useRef } from 'react';
import useSearchParams from '../SearchFilters.hooks';
import { parse } from '../../../util/urlHelpers';
import { useIntl } from 'react-intl';

import css from './SearchPageStyles.module.css';

const SEARCH_PARAM = 'enginePower';
const DEBOUNCE_DELAY = 500;

const stripHP = value => value?.toString().replace(/\s*hp$/i, '');

const EnginePowerFilter = () => {
  const { handleValueChanged, handleResetFilter, search } = useSearchParams({
    searchParamName: SEARCH_PARAM,
  });

  const parsedRaw = stripHP(parse(search)[SEARCH_PARAM] || '');
  const [inputValue, setInputValue] = useState(parsedRaw ? `${parsedRaw} HP` : '');
  const inputRef = useRef(null);
  const debounceTimer = useRef(null);
  const isFocused = useRef(false);

  const intl = useIntl();

  useEffect(() => {
    if (!isFocused.current) {
      setInputValue(parsedRaw ? `${parsedRaw} HP` : '');
    }

    inputRef.current?.blur?.();
    isFocused.current = false;
  }, [parsedRaw]);

  const handleInputChange = e => {
    const raw = stripHP(e.target.value);
    setInputValue(e.target.value);

    clearTimeout(debounceTimer.current);

    if (raw === '') {
      debounceTimer.current = setTimeout(() => {
        handleResetFilter();
      }, DEBOUNCE_DELAY);
    } else {
      debounceTimer.current = setTimeout(() => {
        handleValueChanged(raw);
      }, DEBOUNCE_DELAY);
    }
  };

  const handleBlur = () => {
    isFocused.current = false;

    const raw = stripHP(inputValue);
    if (raw) {
      setInputValue(`${raw} HP`);
    }
  };

  const handleFocus = () => {
    isFocused.current = true;
    setInputValue(stripHP(inputValue));
    clearTimeout(debounceTimer.current);
  };

  useEffect(() => {
    return () => {
      clearTimeout(debounceTimer.current);
    };
  }, []);

  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      pattern="[0-9]*"
      min="0"
      value={inputValue}
      onChange={handleInputChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={intl.formatMessage({ id: 'SearchFilters.enginePowerPlaceholder' })}
      className={css.dropdownLabel}
    />
  );
};

export default EnginePowerFilter;
